import { render, staticRenderFns } from "./LinkTreeItem.vue?vue&type=template&id=baae0dcc"
import script from "./LinkTreeItem.vue?vue&type=script&lang=js"
export * from "./LinkTreeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default})
